import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SimpleTravelService } from '../product/simple-travel.service';
import { AngularLoadingBarService } from 'ng4-loader-bar';
import { TranslateService } from '@ngx-translate/core';
import {ImageCropperComponent, CropperSettings, Bounds} from 'ng2-img-cropper';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';

@Component({
  selector: 'b4a-image-upload',
  templateUrl: './image.upload.html',
  styleUrls: ['./../product/simple-travel-form/simple-travel-form.component.css', './image.upload.css'],
})
export class ImageUploadComponent implements OnInit, OnChanges {
  data: any;
  cropperSettings1: CropperSettings;

  errorOnDeteleImage = 'Delete image failed!';
  successOnDeleteImage = 'Image deleted!';
  comfirmDialogForDelete = 'Are you sure ?'
  errorOnChangeMainImage = 'Change of main image failed!';
  successOnChangeMainImage= 'Main image changed!'
  errorOnUploading= 'Image uploading failed!'
  successOnUploading = 'Image uploaded!'
  deleteExistingImageForBasicTravel = 'You will delete existing image. Continue?'
  selectedWrongImgFormat = 'Please select correct image format!'

  // tslint:disable-next-line:max-line-length
  @Output() outputShowGallery: EventEmitter<boolean> = new EventEmitter<boolean>(); // this will emit true/false in order to show or hide gallery when images count are 0
  @Output() spinnerLoading: EventEmitter<boolean> = new EventEmitter<boolean>(); // this will emit T/F in order to show or hide spinner loader
  @Output() travelResponse = new EventEmitter<any>();
  @Output()
  @Output()

  @Input()
  travel

  @Input()
  file

  @Input()
  showGallery

  @Input()
  premium

  @Input()
  nameOffile

  @Input()
  enableUpload

  imagesArray: any[];
  tenantCode;


  imageChangedEvent: any = '';
  croppedImage: any = '';

  constructor (private simpleTravelService: SimpleTravelService,
              private angularLoadingBarService: AngularLoadingBarService,
              private translate: TranslateService,
              private toastr: ToastrService) {
                // this.langExtension = this.translate.currentLang;
                this.cropperSettings1 = new CropperSettings();
                this.cropperSettings1.width = 500;
                this.cropperSettings1.height = 300;
                this.cropperSettings1.croppedWidth = 350;
                this.cropperSettings1.croppedHeight = 225;
                this.cropperSettings1.canvasWidth = 350;
                this.cropperSettings1.canvasHeight = 225;
                this.cropperSettings1.minWidth = 500;
                this.cropperSettings1.minHeight = 300;
                this.cropperSettings1.minWithRelativeToResolution = true;
                this.cropperSettings1.rounded = false;
                this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
                this.cropperSettings1.cropperDrawSettings.strokeWidth = 2;

                this.data = {};

                this.translate.getTranslation(this.translate.currentLang).subscribe(
                  done => {
                     this.successOnChangeMainImage = done['pop-up-message'].successOnChangeMainImage
                     this.errorOnChangeMainImage = done['pop-up-message'].errorOnChangeMainImage
                     this.errorOnUploading = done['pop-up-message'].errorOnUploading
                     this.successOnUploading = done['pop-up-message'].successOnUploading
                     this.errorOnDeteleImage = done['pop-up-message'].errorOnDeleteImag
                     this.successOnDeleteImage = done['pop-up-message'].successOnDeleteImage
                     this.comfirmDialogForDelete = done['pop-up-message'].comfirmDialogForDelete
                     this.deleteExistingImageForBasicTravel = done['pop-up-message'].deleteExistingImageForBasicTravel
                     this.selectedWrongImgFormat = done['pop-up-message'].selectedWrongImgFormat

                  })
              }



fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    document.getElementById('cropped-immage').removeAttribute('hidden')
  document.getElementById('image-cropper').removeAttribute('hidden')
  document.getElementById('button-upload').removeAttribute('hidden')
}
imageCropped(image: string) {
    this.croppedImage = image;
}

loadImageFailed() {
  console.log('nije ucitana')
  this.spinnerLoading.emit(false);
  this.angularLoadingBarService.complete()
  this.toastr.warning(this.selectedWrongImgFormat)
  document.getElementById('cropped-immage').setAttribute('hidden', 'true')
  document.getElementById('image-cropper').setAttribute('hidden', 'true')
  document.getElementById('button-upload').setAttribute('hidden', 'true')
  document.getElementById('input-for-file')['value'] = '' // deleting selected file from the DOM
}

ngOnInit() {
  let temTenantCode = JSON.parse(localStorage.getItem('sessionData'))

  this.tenantCode = temTenantCode.tenantCode;

  this.imagesPagination()

}

imageUrl(tenantCode, uploadId: number): string {
  return this.simpleTravelService.getImageUrl(tenantCode, uploadId);
}
cropped(bounds: Bounds) {
  console.log(bounds);
}

ngOnChanges() {
  this.imagesPagination()
}
    uploadImageFunction(file, data) {
      let nameOfImg = document.getElementsByTagName('img-cropper')
      this.nameOffile =  document.getElementById('input-for-file')['files'][0].name
      let  binaryString = file.substring(file.indexOf(',') + 1);
      let test = file.split(';');
      let test1 = test[0].split(':')

      // let fileBrowser = this.fileInput.nativeElement;
      let isMain
      if (typeof this.travel.files === 'undefined' || this.travel.files.length === 0) {
        isMain = true
      }else {
        isMain = false;
      }
      if (!this.premium) {
            if (this.travel.files.length === 1) {
              var r = confirm(this.deleteExistingImageForBasicTravel);
              if (r === true) {
      this.deleteImage(this.travel.files[0].assignment)
              }
            }
          }
          this.spinnerLoading.emit(true);
      this.simpleTravelService.uploadFile(test1[1] , binaryString, this.nameOffile, this.travel.id, isMain).subscribe(
        data =>  {  this.toastr.success(this.successOnUploading)
        if (isMain) {
          this.travel.files = []
          this.travel.files.unshift(data)
        }else {
          this.travel.files.unshift(data)
        }
        this.imagesPagination();
        this.outputShowGallery.emit(true);
        this.showGallery = true;
        this.spinnerLoading.emit(false);
        this.angularLoadingBarService.complete()
        this.travelResponse.emit(this.travel)


  document.getElementById('cropped-immage').setAttribute('hidden', 'true')
  document.getElementById('image-cropper').setAttribute('hidden', 'true')
  document.getElementById('button-upload').setAttribute('hidden', 'true')
  document.getElementById('input-for-file')['value'] = '' // deleting selected file from the DOM

  this.imageChangedEvent = '';
  this.croppedImage = '';
        },
        err => { this.toastr.error(this.errorOnUploading), this.spinnerLoading.emit(false), console.log(err)})
      }


    changeImageMainPriperty(assignmentId) {
      for (let i = 0; i < this.travel.files.length; i++) {
          this.travel.files[i].main = false;
          if (this.travel.files[i].assignment === assignmentId) {
            this.travel.files[i].main = true;
          }
      }

      this.simpleTravelService.getSpecifisAaignment(assignmentId).subscribe(
        data => {console.log(data)
         data.main = true, this.simpleTravelService.changeAssignmentOfImage(data).subscribe(
          data1 => this.toastr.success(this.successOnChangeMainImage),
          err1 => this.toastr.error(this.errorOnChangeMainImage),
          () => console.log('complete1')
        )
        },
        err => this.toastr.error(this.errorOnChangeMainImage),
        () => console.log('complete')
      )
    }

    deleteImage(assignment) {
      let r = confirm(this.comfirmDialogForDelete);
      if (r === true) {
          this.simpleTravelService.deleteAssignment(assignment).subscribe(
            data1 => {
              for (let i = 0; i < this.travel.files.length; i++) {
                if (this.travel.files[i].assignment === assignment) {
                  this.travel.files.splice(i, 1)
                }
              }
              if (this.travel.files.length === 0) {
                this.outputShowGallery.emit(false)
                this.showGallery = false;
              }
              this.imagesPagination()
              this.toastr.success(this.successOnDeleteImage)
            },
            err1 => this.toastr.error(this.errorOnDeteleImage),
            () => console.log('complete1')
          )
      }
    }

    imagesPagination() {
      if (typeof this.travel.files !== 'undefined') {
        this.imagesArray = new Array();
        for (let i = 0; i < Math.ceil(this.travel.files.length / 3); i++) {
          this.imagesArray[i] = [];
        }
        let counter = 0;
        let secondCounter = 3;
        let arrayCounter = 0;
        for (let i = 0; i < this.travel.files.length; i++) {
          if (counter < secondCounter) {
            this.imagesArray[arrayCounter].push(
              this.travel.files[i]
            )
            counter++
          }
          if (counter  === secondCounter) {
            secondCounter += 3
            arrayCounter++
          }
        }
      }
    }

    openChooseFileDialog() {
      document.getElementById('input-for-file').click()
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/image.upload.ts